import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ApiContext } from '@shared/contexts';
import { TOrganization } from '../types/organizations.types';

export const useOrganization = () => {
  const { apiClient, useHandleQueryError, retry } = useContext(ApiContext);

  const getOrganization = (): Promise<TOrganization> => apiClient.get(`/organizations/my`).then((res) => res.data);

  const { data, isError, error } = useQuery({
    retry,
    queryKey: ['organization'],
    queryFn: getOrganization,
  });
  useHandleQueryError(isError, error);

  return data;
};
